(function () {
  const STORAGE_KEY = "theme-wishlist-handles-v1";
  const drawerListSelector = "[data-wishlist-list]";
  const drawerEmptySelector = "[data-wishlist-empty]";
  const countSelector = "[data-wishlist-count]";

  function readWishlist() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      if (Array.isArray(parsed)) {
        return parsed.filter(Boolean);
      }
    } catch (error) {
      console.warn("Wishlist read failed", error);
    }
    return [];
  }

  function writeWishlist(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  }

  function isInWishlist(handle) {
    return readWishlist().includes(handle);
  }

  function toggleWishlist(handle) {
    const handles = readWishlist();
    const index = handles.indexOf(handle);

    if (index === -1) {
      handles.push(handle);
    } else {
      handles.splice(index, 1);
    }

    writeWishlist(handles);
    updateWishlistUI();
  }

  function setWishlistCount() {
    const count = readWishlist().length;
    document.querySelectorAll(countSelector).forEach((element) => {
      element.textContent = String(count);
      element.classList.toggle("is-visible", count > 0);
    });
  }

  function updateToggleButtons() {
    const handles = readWishlist();
    document.querySelectorAll("[data-wishlist-toggle]").forEach((button) => {
      const handle = button.getAttribute("data-product-handle");
      if (!handle) return;

      const active = handles.includes(handle);
      button.setAttribute("aria-pressed", active ? "true" : "false");
      button.classList.toggle("is-active", active);
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, window.themeVariables?.settings?.moneyFormat);
    }

    return `$${(cents / 100).toFixed(2)}`;
  }

  async function fetchProduct(handle) {
    const response = await fetch(`/products/${handle}.js`, { credentials: "same-origin" });
    if (!response.ok) return null;
    return response.json();
  }

  async function renderWishlistDrawer() {
    const drawerList = document.querySelector(drawerListSelector);
    const drawerEmpty = document.querySelector(drawerEmptySelector);

    if (!drawerList || !drawerEmpty) return;

    const handles = readWishlist();
    drawerList.innerHTML = "";

    if (handles.length === 0) {
      drawerEmpty.hidden = false;
      return;
    }

    drawerEmpty.hidden = true;
    const products = (await Promise.all(handles.map(fetchProduct))).filter(Boolean);

    if (products.length === 0) {
      drawerEmpty.hidden = false;
      return;
    }

    products.forEach((product) => {
      const variant = product.variants.find((item) => item.available) || product.variants[0];
      const item = document.createElement("li");
      item.className = "wishlist-drawer__item";
      item.setAttribute("data-handle", product.handle);

      const image = product.featured_image ? `<img src="${product.featured_image}" alt="${product.title}" loading="lazy" class="wishlist-drawer__image">` : "";
      const price = typeof product.price === "number" ? formatMoney(product.price) : "";
      const addToBagDisabled = !variant || !variant.available;

      item.innerHTML = `
        <a class="wishlist-drawer__media" href="${product.url}">${image}</a>
        <div class="wishlist-drawer__content">
          <a class="wishlist-drawer__title" href="${product.url}">${product.title}</a>
          <p class="wishlist-drawer__price">${price}</p>
          <div class="wishlist-drawer__actions">
            <button type="button" class="button button--sm" data-wishlist-add-bag="${variant ? variant.id : ""}" ${addToBagDisabled ? "disabled" : ""}>
              ${addToBagDisabled ? "Sold Out" : "Add to Bag"}
            </button>
            <button type="button" class="link text-sm" data-wishlist-remove="${product.handle}">Remove</button>
          </div>
        </div>
      `;

      drawerList.appendChild(item);
    });
  }

  async function addToCart(variantId) {
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    });

    if (!response.ok) return;

    document.dispatchEvent(new CustomEvent("cart:refresh"));
    const cartTrigger = document.querySelector('a[aria-controls="cart-drawer"]');
    cartTrigger?.click();
  }

  function removeFromWishlist(handle) {
    const handles = readWishlist().filter((item) => item !== handle);
    writeWishlist(handles);
    updateWishlistUI();
  }

  async function updateWishlistUI() {
    setWishlistCount();
    updateToggleButtons();
    await renderWishlistDrawer();
  }

  document.addEventListener("click", async (event) => {
    const toggle = event.target.closest("[data-wishlist-toggle]");
    if (toggle) {
      event.preventDefault();
      const handle = toggle.getAttribute("data-product-handle");
      if (!handle) return;
      toggleWishlist(handle);
      return;
    }

    const removeButton = event.target.closest("[data-wishlist-remove]");
    if (removeButton) {
      event.preventDefault();
      removeFromWishlist(removeButton.getAttribute("data-wishlist-remove"));
      return;
    }

    const addButton = event.target.closest("[data-wishlist-add-bag]");
    if (addButton) {
      event.preventDefault();
      const variantId = addButton.getAttribute("data-wishlist-add-bag");
      if (!variantId) return;
      addButton.disabled = true;
      await addToCart(variantId);
      addButton.disabled = false;
    }
  });

  document.addEventListener("DOMContentLoaded", updateWishlistUI);
})();
